import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useServices } from "./app-context";

/**
 * `t` with the tenant name always available for interpolation
 * (`{{tenant}}` appears in many keys).
 */
export function useT() {
  const { t } = useTranslation();
  const { config } = useServices();
  const tenant = config.brand.name;
  // Stable identity: effects that list `t` must not rerun every render.
  return useCallback(
    (key: string | string[], values: Record<string, unknown> = {}) =>
      t(key, { tenant, ...values }) as string,
    [t, tenant],
  );
}
